import {Component, OnInit} from '@angular/core';
import {FormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, NgForm} from '@angular/forms';
import {CommonValidators} from '../../shared/common-components/common-validators';
import {ForgotPasswordService} from 'src/app/services/forgot-password/forgot-password.service';
import {LoggerService} from '../../shared/common-components/logger.service';
import {ForgotPassword} from '../../shared/common-components/common-structure';
import {LoadingService} from '../../services/loading/loading.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ConfirmationModalComponent } from 'src/app/shared/common-components/confirmation-modal/confirmation-modal.component';
import { Router } from '@angular/router';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.css'],
    standalone: false
})
export class ForgotPasswordComponent implements OnInit {
  forgotPasswordForm: UntypedFormGroup;
  requestSubmitted: Boolean = false;
  errorSubmittingRequest: Boolean = false;
  modalRef: BsModalRef;

  constructor(private fb: UntypedFormBuilder,
              private loggerService: LoggerService,
              private forgotPasswordSerivce: ForgotPasswordService,
              private tmssloader: LoadingService,
              private modalService: BsModalService,
              private router: Router) {

    this.forgotPasswordForm = this.fb.group({
      lastName: new UntypedFormControl('', Validators.required),
      email: new UntypedFormControl('', [Validators.required, CommonValidators.email])
    });
  }

  submitRequest() {
    this.tmssloader.show();
    this.requestSubmitted = false;
    this.errorSubmittingRequest = false;
    this.loggerService.log('submitted forgotPassword request');
    this.loggerService.log('the userProfileForm is ', this.forgotPasswordForm);
    const forgotPassword: ForgotPassword = new ForgotPassword();
    forgotPassword.lastName = this.forgotPasswordForm.get('lastName').value;
    forgotPassword.email = this.forgotPasswordForm.get('email').value;
    this.forgotPasswordSerivce.create(forgotPassword).subscribe(response => {
        this.tmssloader.hide();
        this.loggerService.log('got a response ', response);
          this.modalRef = this.modalService.show(ConfirmationModalComponent);
          this.modalRef.content.question = 'Please proceed to the Login Page';
          this.modalRef.content.title = 'Email Sent With Further Instructions';
          this.modalRef.content.confirmText = 'Proceed to Sign In';
          this.modalRef.content.hideCloseButton = true;
          //this.modalRef.content.cancelText = 'No';
          this.modalRef.content.emitData.subscribe(result => {
            if (result.obj === true) {
              this.router.navigate(['/signon']);
            }
          }, () => {
        });        
      },
      err => {
        this.tmssloader.hide();
        this.errorSubmittingRequest = true;
        this.loggerService.log('got an error response ', err);
     }
    );
    this.requestSubmitted = true;

  }

  ngOnInit() {
  }

}
